import { xyFilterX } from 'ml-spectra-processing';
import { addChartDataStyle } from './addChartDataStyle.js';
/**
 * Get chart with normalized data
 * @param spectra - Array of spectrum objects
 * @param options - Chart options
 * @returns Chart object with normalized data
 */
export function getNormalizedChart(spectra, options = {}) {
    const { xFilter } = options;
    const chart = {
        data: [],
    };
    for (const spectrum of spectra) {
        let data = spectrum.normalized;
        if (xFilter) {
            data = xyFilterX(data, xFilter);
        }
        addChartDataStyle(data, spectrum);
        chart.data.push(data);
    }
    return chart;
}
//# sourceMappingURL=getNormalizedChart.js.map